"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const contexts_1 = require("@App/contexts");
const react_router_dom_1 = require("react-router-dom");
require("./index.scss");
const OverclaimViewHeader_1 = require("@Components/OverclaimView/Headers/OverclaimViewHeader");
const mobx_react_1 = require("mobx-react");
const OverclaimExtendedWorkItem_1 = __importDefault(require("@Components/WorkItemV2/OverclaimAndDisputes/OverclaimExtendedWorkItem"));
const react_helmet_1 = __importDefault(require("react-helmet"));
const overclaim_1 = require("@App/api/routes/overclaim");
const lodash_1 = require("lodash");
const TabsWrapperComponent_1 = __importDefault(require("@Components/TabsWrapperComponent"));
const OverclaimDetailTab_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderOverclaim/OverclaimView/OverclaimDetailTab"));
const clsx_1 = __importDefault(require("clsx"));
const OverclaimHistoryTab_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderOverclaim/OverclaimView/OverclaimHistoryTab"));
const OverclaimDocumentTab_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderOverclaim/OverclaimView/OverclaimDocumentTab"));
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const Sidebar_1 = require("@Components/Sidebars/Sidebar");
const UploadDocumentsForm_1 = __importDefault(require("@Components/OverclaimView/UploadDocumentsForm"));
const react_sdk_1 = require("@openfeature/react-sdk");
const OverclaimView = () => {
    const { overclaimViewStore, preloaderStore, rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const params = (0, react_router_dom_1.useParams)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { value: showDocumentUpload } = (0, react_sdk_1.useFlag)('overclaim-document-upload', false);
    const [uploadDocumentsFormIsOpen, setUploadDocumentsFormIsOpen] = (0, react_1.useState)(false);
    const overclaimHeaderId = params.overclaimHeaderId && +params.overclaimHeaderId;
    const onAmend = () => __awaiter(void 0, void 0, void 0, function* () {
        if (overclaimViewStore.overclaimViewItem && overclaimHeaderId) {
            const overclaimViewItemCopy = (0, lodash_1.cloneDeep)(overclaimViewStore.overclaimViewItem);
            overclaimViewItemCopy.originalPublishers = overclaimViewItemCopy.originalPublishers.filter((publisher) => publisher.topMemberIpId === rightsholderStore.currentRightsholderId);
            yield (0, overclaim_1.amendOverclaimShares)(overclaimHeaderId, rightsholderStore.currentRightsholderId, overclaimViewItemCopy);
        }
    });
    const overclaimTabs = [
        {
            tabName: 'Detail',
            tabComponent: (react_1.default.createElement(OverclaimDetailTab_1.default, { onAmend: onAmend, onClickUploadDocumentsOption: () => setUploadDocumentsFormIsOpen(true) })),
        },
        ...(showDocumentUpload
            ? [
                {
                    tabName: 'Documents',
                    tabComponent: (react_1.default.createElement(OverclaimDocumentTab_1.default, { onClickUploadDocumentsOption: () => setUploadDocumentsFormIsOpen(true) })),
                },
            ]
            : []),
        {
            tabName: 'History',
            tabComponent: react_1.default.createElement(OverclaimHistoryTab_1.default, null),
        },
    ];
    (0, react_1.useEffect)(() => {
        var _a;
        if (!overclaimViewStore.overclaimViewItem ||
            (overclaimHeaderId && ((_a = overclaimViewStore.overclaimViewItem) === null || _a === void 0 ? void 0 : _a.overclaimHeaderId) !== overclaimHeaderId)) {
            if (overclaimHeaderId) {
                preloaderStore.openMainPreloader(true);
                overclaimViewStore
                    .getOverclaimViewItemByHeaderId(overclaimHeaderId, rightsholderStore.currentRightsholderId)
                    .finally(() => {
                    preloaderStore.openMainPreloader(false);
                });
            }
            else {
                navigate(`/member/${rightsholderStore.currentRightsholderId}`);
            }
        }
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.default, { title: 'Overclaim Detail' }),
        overclaimViewStore.overclaimViewItem && (react_1.default.createElement("div", { className: (0, clsx_1.default)('overclaim-view-container') },
            react_1.default.createElement(OverclaimViewHeader_1.OverclaimViewHeader, { songTitle: overclaimViewStore.overclaimViewItem.title }),
            react_1.default.createElement("div", { className: "overclaim-view-item" },
                react_1.default.createElement("div", { className: "overclaim-view-item-body" },
                    react_1.default.createElement("div", { className: "total-overclaim-container" },
                        react_1.default.createElement(OverclaimExtendedWorkItem_1.default, { work: overclaimViewStore.overclaimViewItem, toCatalog: true })),
                    react_1.default.createElement(TabsWrapperComponent_1.default, { tabs: overclaimTabs, defaultTab: overclaimTabs[0], preventScrollReset: true }))))),
        react_1.default.createElement(ModalPortal_1.default, { isOpen: uploadDocumentsFormIsOpen }, uploadDocumentsFormIsOpen && (react_1.default.createElement(Sidebar_1.Sidebar, { onClose: () => {
                setUploadDocumentsFormIsOpen(false);
            } },
            react_1.default.createElement(UploadDocumentsForm_1.default, { onDoneClicked: () => {
                    setUploadDocumentsFormIsOpen(false);
                    navigate('#documents', { state: (0, lodash_1.random)() });
                } }))))));
};
exports.default = (0, mobx_react_1.observer)(OverclaimView);
